import { render } from "./MessangerComp.vue?vue&type=template&id=069d49a0&scoped=true"
import script from "./MessangerComp.vue?vue&type=script&lang=js"
export * from "./MessangerComp.vue?vue&type=script&lang=js"

import "./MessangerComp.vue?vue&type=style&index=0&id=069d49a0&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069d49a0"]])

export default __exports__